import { Badge } from '@usealloy/component-library';
import { accessLabelBadgeStatusMap } from './constants';

interface AccessBadgeProps {
  /** Display label already produced by `getTableData` (e.g. "Permanent", "Pending", "Request Access") */
  accessLabel: string;
}

/**
 * Presentational badge for a customer row's RBAC access status in the
 * "All Customers" section.
 */
export const AccessBadge = ({ accessLabel }: AccessBadgeProps) => (
  <Badge status={accessLabelBadgeStatusMap[accessLabel] ?? 'neutral'}>
    {accessLabel}
  </Badge>
);
